<template>
	<div
		class="time-ticket-week-circle"
		:class="value > 0 ? `time-ticket-week-circle--${color}` : null">
		<div class="time-ticket-week-circle__circle">
			{{ value }}
		</div>
		<div class="time-ticket-week-circle__label">
			{{ label }}
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { TimeTicketWeekCircleEmits, TimeTicketWeekCircleProps } from './TimeTicketWeekCircleSetup';
import TimeTicketWeekCircleSetup from './TimeTicketWeekCircleSetup';
const emits = defineEmits<TimeTicketWeekCircleEmits>() as TimeTicketWeekCircleEmits;
const props = withDefaults(defineProps<TimeTicketWeekCircleProps>(), TimeTicketWeekCircleSetup.defaultProps);
const setup = new TimeTicketWeekCircleSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/variables";
@import "@/styles/mixins";

.time-ticket-week-circle {
	display: flex;
	align-items: center;

	&__circle {
		.circle(40px);
		.flex-align();

		border-color: var(--grey-light);
		border-style: solid;
		border-width: 2px;
		font-size: 1.125rem;
		font-weight: 600;
		color: var(--grey);
	}

	&__label {
		margin-left: 0.625rem;
		font-size: 0.75rem;
		font-weight: 600;
		line-height: 15px;
		text-transform: uppercase;
	}

	each(@circleColors, {
		@color: ~"--@{value}";
		&--@{value} .time-ticket-week-circle__circle {
			border-color: var(@color);
			color: var(@color);
		}
	});
}
</style>
